module.exports = __webpack_public_path__ + "img/1369467791.f5252c2e.jpg";